module.exports = __webpack_public_path__ + "static/media/TUNE_1500.7d8aa2e3.jpg";